import e from "react";
const a = (t) => e.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 16 16", width: "16", height: "16" }, t),
  e.createElement(
    "g",
    { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
    e.createElement("path", { d: "M12.179384,9.99652927 C13.3121335,11.2098914 14.5094001,12.4468664 15.7711838,13.7074543 C16.0856442,14.1312433 16.0237692,14.6280052 15.7134309,14.935198 C15.4030925,15.2423907 14.8517396,15.3435259 14.4263062,15.0387002 C13.2202388,13.8192498 12.0549415,12.6112154 10.9304143,11.4145971 C9.75469896,12.4979146 8.18748267,13 6.5,13 C3.04351467,13 0,9.993215 0,6.5 C0,3.00678071 3.04351467,0 6.5,0 C9.95648427,0 12.9755807,2.61636862 13,6.5 C13.0092773,7.97546387 12.7246758,9.09439671 12.179384,9.99652927 Z M6.50000268,11 C8.98528503,11 11,8.98528204 11,6.50000213 C11,4.01472436 8.98528503,2 6.50000268,2 C4.01472034,2 2,4.01472436 2,6.50000213 C2,8.98528204 4.01472034,11 6.50000268,11 Z" })
  )
);
a.displayName = "MagGlass16x16";
export {
  a as I
};
//# sourceMappingURL=MagGlass16x16-C5rwnQuW.mjs.map
